'use client';

import { useEffect } from 'react';
import { EXTENSION_FRAME_HEADER, extensionAncestor, isLaneRequest } from '@/lib/extension-lane';

declare global {
  interface Window {
    __iaExtensionLane?: boolean;
  }
}

/**
 * Inside the Chrome extension's side panel, mark the page's search requests
 * with the extension origin it sits in (lib/extension-lane.ts). Mounted right
 * after BotIdBoot, so it wraps the fetch BotID already instruments, and before
 * any child's effect, so the first search already carries the marker. Nothing
 * happens on a page opened normally.
 */
export function ExtensionFrameMarker() {
  useEffect(() => {
    if (window.__iaExtensionLane) return;
    const origin = extensionAncestor(window.location);
    if (!origin) return;
    window.__iaExtensionLane = true;
    const inner = window.fetch.bind(window);
    window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
      if (!isLaneRequest(url, window.location.origin)) return inner(input, init);
      const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
      headers.set(EXTENSION_FRAME_HEADER, origin);
      return inner(input, { ...init, headers });
    };
  }, []);
  return null;
}
